import React, { useState, useEffect, useCallback } from 'react';
import './Toast.css';

let toastId = 0;
let pushToast = null;

/** 全局 Toast：toast.success('文字') / toast.error('文字') */
export const toast = {
  success: (text) => pushToast && pushToast({ id: ++toastId, type: 'success', text }),
  error: (text) => pushToast && pushToast({ id: ++toastId, type: 'error', text }),
  info: (text) => pushToast && pushToast({ id: ++toastId, type: 'info', text }),
};

// 兼容旧版默认导出：Toast.success/error/warning(info)
const Toast = {
  success: (t) => toast.success(t),
  error: (t) => toast.error(t),
  info: (t) => toast.info(t),
  warning: (t) => toast.error(t),
};
export default Toast;

export const ToastContainer = () => {
  const [items, setItems] = useState([]);
  const push = useCallback((t) => {
    setItems((prev) => [...prev, t]);
    setTimeout(() => {
      setItems((prev) => prev.filter((x) => x.id !== t.id));
    }, 3200);
  }, []);
  useEffect(() => { pushToast = push; return () => { pushToast = null; }; }, [push]);

  return (
    <div className="toast-wrap">
      {items.map((t) => (
        <div key={t.id} className={`toast toast-${t.type}`}>
          {t.type === 'success' ? '✓' : t.type === 'error' ? '✕' : 'ℹ'} {t.text}
        </div>
      ))}
    </div>
  );
};
